export const SET_QUIZ_ANSWERS = 'user/SET_QUIZ_ANSWERS';
export const SET_EMAIL = 'user/SET_EMAIL';
export const SET_CODE = 'user/SET_CODE';
export const SET_ERROR_MSG = 'user/SET_ERROR_MSG';
export const SET_SELECTED_PLAN = 'user/SET_SELECTED_PLAN';
export const SET_SUMMARY = 'user/SET_SUMMARY';
